import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { AuthGate } from './features/auth/AuthGate'
import './styles.css'
import { I18nProvider } from './lib/i18n'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import { UpdatePrompt } from './components/UpdatePrompt'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary><I18nProvider><AuthGate><App /></AuthGate><UpdatePrompt /></I18nProvider></AppErrorBoundary>
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  let refreshing=false
  navigator.serviceWorker.addEventListener('controllerchange',()=>{if(!refreshing){refreshing=true;window.location.reload()}})
  window.addEventListener('load', async () => {
    try {
      const registration=await navigator.serviceWorker.register('/sw.js')
      const announce=(worker:ServiceWorker|null)=>worker&&window.dispatchEvent(new CustomEvent('clashcards:update-ready',{detail:worker}))
      if(registration.waiting)announce(registration.waiting)
      registration.addEventListener('updatefound',()=>registration.installing?.addEventListener('statechange',()=>{if(registration.waiting&&navigator.serviceWorker.controller)announce(registration.waiting)}))
    } catch {
      // The online app remains usable when service worker registration is unavailable.
    }
  })
}
